function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderFunctionsOpen = function SvgFolderFunctionsOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19 20H4a2 2 0 0 1-2-2V6c0-1.11.89-2 2-2h6l2 2h7c1.097 0 2 .903 2 2H4v10l2.14-8h17.07l-2.28 8.5c-.23.87-1.01 1.5-1.93 1.5z",
    fill: "#01579B",
    style: {
      fill: "#0288d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.66 10.789c-.70846-.06441-1.3332.45729-1.3976 1.1722l-.16101 1.8614h1.8162v1.2881h-1.9322l-.28338 3.2654c-.12881 1.417-1.3783 2.4668-2.7952 2.338-.80506-.07085-1.5328-.51526-1.9579-1.2044l.96608-.9661c.21254.67627.94031 1.0563 1.6101.83729.50236-.15458.85658-.59898.90167-1.1207l.2705-3.1495h-1.9322v-1.2881h2.0481l.17389-1.9773c.12237-1.4169 1.3654-2.4668 2.7887-2.3508.8115.07085 1.5457.52169 1.9708 1.2173l-.96608.9661c-.16101-.49593-.59897-.84373-1.1206-.88881m6.17 5.3844-.90811-.90814-1.8227 1.8227-1.8227-1.8227-.92099.90814 1.8355 1.8356-1.8355 1.8098.92099.90814 1.8227-1.8227 1.8227 1.8227.90811-.90814-1.8227-1.8098z",
    style: {
      fill: "#b3e5fc",
      strokeWidth: 0.64406
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderFunctionsOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-functions-open.19020f79.svg";
export { ForwardRef as ReactComponent };